import { AxiosResponse } from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { device, tagUrl } from "../helpers";
import { Tag } from "../models";

const Container = styled.div<{ marginTop: number }>`
    position: sticky;
    z-index: 1;
    padding: 10px;
    background-color: #fff;
    top: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin-top: ${(p) => p.marginTop}px;
    padding-right: 5px;
    width: 100%;

    @media ${device.phone} {
        display: none;
    }
`;

const List = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
`;
const Item = styled.div<{ active: boolean }>`
    user-select: none;
    margin-left: 24px;

    a {
        font-size: 16px;
        font-weight: 500;
        font-family: Cairo, QuranFont, urdu, sans-serif;
        text-decoration: none;
        color: ${(p) => (p.active ? "#000" : "#8e8e8e")};

        span {
            font-weight: 500;
        }

        &:hover {
            color: #000;
        }
    }

    &:last-child {
        margin-left: 0;
    }
`;

type Props = {
    marginTop?: number;
};

type TagState = {
    id: number;
    name: string;
};

export default function Tags({ marginTop }: Props) {
    const [tags, setTags] = useState<TagState[]>([]);

    useEffect(() => {
        fetch();
    }, []);

    const fetch = async () => {
        try {
            const { data: tags }: AxiosResponse<TagState[]> = await Tag.list();
            setTags(tags);
        } catch (e) {}
    };

    const { tag_id } = useParams<{ tag_id: string }>();
    const location = useLocation();
    const param_tag_id =
        location.pathname.startsWith("/t-") && tag_id ? parseInt(tag_id) : -1;

    return (
        <Container marginTop={marginTop || 0}>
            <List>
                <Item key="tag-featured" active={param_tag_id === -1}>
                    <Link to="/app/">تازہ ترین</Link>
                </Item>
                {tags.map((t) => (
                    <Item key={`tag-${t.id}`} active={param_tag_id === t.id}>
                        <Link to={tagUrl(t)}>{t.name}</Link>
                    </Item>
                ))}
            </List>
        </Container>
    );
}
